import { render, staticRenderFns } from "./WeekTaskContents.vue?vue&type=template&id=ecd65b64&scoped=true&"
import script from "./WeekTaskContents.vue?vue&type=script&lang=ts&"
export * from "./WeekTaskContents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd65b64",
  null
  
)

export default component.exports